import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function receiptDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/receipt/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
